(function() {
  'use strict';

  function isGPCApplied() {
    return window.__GPC_STATUS__ && window.__GPC_STATUS__.shouldApplyGPC === true;
  }

  function notifyConsentManager() {
    if (!isGPCApplied()) return;

    function sendGPCSignal() {
      if (typeof window.__cmp === 'function') {
        try {
          window.__cmp('setGPCSignal', true);
          console.log('[GPC] Notified ConsentManager: GPC signal active');
        } catch(e) {}
      }
      if (typeof window.cmpApi === 'object' && window.cmpApi.setGpc) {
        try {
          window.cmpApi.setGpc(true);
        } catch(e) {}
      }
      if (typeof window.__tcfapi === 'function') {
        try {
          window.__tcfapi('setGPCSignal', 2, function() {}, true);
        } catch(e) {}
      }
    }

    sendGPCSignal();

    window.addEventListener('cmp.ready', sendGPCSignal);
    window.addEventListener('CMP.ready', sendGPCSignal);

    var observer = new MutationObserver(function() {
      if (typeof window.__cmp === 'function' || typeof window.cmpApi === 'object') {
        sendGPCSignal();
        observer.disconnect();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function() { observer.disconnect(); }, 10000);
  }

  function blockMarketingScripts() {
    if (!isGPCApplied()) return;

    var omegaScripts = document.querySelectorAll('script[src*="omegatheme.com"]');
    omegaScripts.forEach(function(script) {
      script.remove();
    });

    console.log('[GPC] Marketing scripts blocked for CA user with GPC signal');
  }

  function init() {
    if (window.__GPC_STATUS__ && window.__GPC_STATUS__.shouldApplyGPC !== undefined) {
      run();
    } else {
      window.addEventListener('gpc:applied', run);
      setTimeout(run, 2000);
    }
  }

  function run() {
    if (!window.__GPC_STATUS__) return;

    console.log('[GPC] California IP:', window.__GPC_STATUS__.isCaliforniaIP);
    console.log('[GPC] GPC Signal:', window.__GPC_STATUS__.gpcEnabled);
    console.log('[GPC] Applied:', window.__GPC_STATUS__.shouldApplyGPC);

    if (isGPCApplied()) {
      notifyConsentManager();
      blockMarketingScripts();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.GPCHandler = {
    isApplied: isGPCApplied,
    getStatus: function() { return window.__GPC_STATUS__; },
    notifyCMP: notifyConsentManager
  };

})();
